import SkipTheCounterFlowTemplate from './SkipTheCounterFlowTemplate';

export default SkipTheCounterFlowTemplate;
